module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_spirink.0c334c26aa42849f151f8fa8f267e560.png";